import NavBar from '../navbar/navbar';
import { Grid, SxProps, Theme, Typography } from '@mui/material';
import useSyndicate from './useSyndicate';
import SyndicateCoupon from './syndicatecoupon';
import useDetailRound from '../rounds/useDetailRound';
import { H2, H3 } from '../reusable-components';
import { getRoundName } from '../common/RoundHelper';
import Moment from 'react-moment';
import { useTranslation } from 'react-i18next';
import { PoolXNumberFormat } from '../common/CurrencyFormatter';
import WinInfo from '../couponview/wininfo';
import { CouponShare } from '../models/couponshares';

export default function SyndicateResult({ syndicateId }: { syndicateId: number }) {

  const syndicateResponse = useSyndicate(syndicateId);
  const roundResponse = useDetailRound(syndicateResponse.syndicate?.roundId);
  const { t } = useTranslation();
  let locale = t('locale');

  const theme = getComputedStyle(document.documentElement).getPropertyValue("--theme-name");

  if (syndicateResponse.error || syndicateResponse.syndicate === undefined
    || roundResponse.error || roundResponse.round === undefined || roundResponse.round.status !== 'FINISHED') return null;

  const style: SxProps<Theme> = {
    background: "var(--background_1)",
    paddingTop: "20px",
    alignItems: "center"
  }

  let rowStyle: SxProps<Theme> = {
    background: 'var(--background_1)',
    alignItems: 'center',
    paddingTop: '30px',
    paddingBottom: '10px',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    width: "auto",
    padding: "5px"
  }

  let textStyle: SxProps<Theme> = {
    fontWeight: 'bold',
  }
  
  const nf = PoolXNumberFormat(locale, { style: 'currency', currency: syndicateResponse.syndicate.stakePerShare.currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
  let formattedStakePerShare = nf.format(syndicateResponse.syndicate.totalAmountPerShare.amount);  

  var groups = syndicateResponse.syndicate.coupon.preliminaryResult.groups;

  const numFixtures = roundResponse.round.fixtures.length;
  const prizePlan = roundResponse.round.operatorPrizePlan;
  let pl = 0;

  if (numFixtures > 11) {   
    pl = groups[0].rows * prizePlan.payoutGroups[0].payoutPerRow.money.amount
      + groups[1].rows * prizePlan.payoutGroups[1].payoutPerRow.money.amount
      + groups[2].rows * prizePlan.payoutGroups[2].payoutPerRow.money.amount;
  }
  else {  
    pl = groups[0].rows * prizePlan.payoutGroups[0].payoutPerRow.money.amount;
  }

  let couponShare = {
    // Cast to CouponShare — only properties used by WinInfo are populated
    totalStakePercentage: 1,
    operatorResult: { amount: pl, currency: syndicateResponse.syndicate.agentFeePerShare.currency },
    coupon: {
      preliminaryResult: {
        groups: groups,
        operatorPrizePlan: prizePlan
      }
    }
  } as unknown as CouponShare;
  return (
    <>
      <NavBar whichToUnderline="2" balanceUpdateId="0" />
      <Grid sx={style} container direction="column">
        <H2>{syndicateResponse.syndicate.name}</H2>
        <H3>{getRoundName(roundResponse.round, t)} <Moment format={"L"} locale={locale}>{roundResponse.round.openTo}</Moment></H3>
        <Grid marginTop="-20px">
          <SyndicateCoupon syndicate={syndicateResponse.syndicate} theme={theme} round={roundResponse.round}></SyndicateCoupon>
          <WinInfo round={roundResponse.round} couponShare={couponShare} isRightToLeft={false} />
        </Grid>
        <Grid marginTop="20px" container direction="row" justifyContent="center">
          <Grid container sx={rowStyle}>
            <Typography>{t('share_price')}:</Typography>
            <Typography sx={textStyle}>{formattedStakePerShare} </Typography>
          </Grid>
          <Grid container sx={rowStyle}>
            <Typography>{t('shares')}:</Typography>
            <Typography sx={textStyle}>{syndicateResponse.syndicate.targetNShares} </Typography>
          </Grid>
          <Grid container sx={rowStyle}>
            <Typography>{t('win_per_share')}:</Typography>
            <Typography sx={textStyle}>{nf.format(pl / syndicateResponse.syndicate.targetNShares)} </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

